import { useState, useEffect } from 'react';
import SearchIcon from '@rsuite/icons/Search';
import debounce from 'lodash/debounce';
import PlusIcon from '@rsuite/icons/Plus';
import api from '../../services/api';
import EditarCadastrarGrupo from './EditarCadastrar';
import ModalImagemGrupo from './ImagemGrupo';
import { InputGroup, Table } from 'rsuite';
import { useAuth } from '../../hooks/auth';
import { useCustomTheme } from '../../hooks/useCustomTheme';
import { ContentHeader } from '../../components/ContentHeader';
import DuvidasButton from '../../components/DuvidasButton';
import { CustomInput } from '../../components/CustomInput';
import { CustomButton } from '../../components/CustomButton';
import { CustomSelectPicker } from '../../components/CustomSelectPicker';
import { CustomHeaderCell } from '../../components/CustomHeaderCell';
import { CustomCell } from '../../components/CustomCell';
import { toastInfo, toastError } from '../../toasts';
import { useCompany } from '../../hooks/useCompany';
import * as S from './styles';
import { FaLayerGroup } from 'react-icons/fa';

const { Column } = Table;

const Grupo = () => {
  const { id_empresa } = useAuth();
  const [buscar, setBuscar] = useState('');
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [grupos, setGrupos] = useState([]);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [grupo, setGrupo] = useState(null);
  const [idGrupo, setIdGrupo] = useState('');
  const [modalImagemGrupo, setModalImagemGrupo] = useState(false);
  const { company } = useCompany();
  const { theme } = useCustomTheme();

  const colStyle = {
    background: theme.colors.backgroundSecondary,
    color: theme.colors.textSecondary,
  };

  const consultar = async (consulta) => {
    if (!consulta) {
      atualizar();
    } else {
      await api
        .post('grupo-produto/listarGruposPorNomeGestor', {
          IdEmpresa: id_empresa,
          Consulta: consulta,
        })
        .then((res) => {
          res.data.length > 0 ? setGrupos(res.data) : setGrupos([]);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const dataAtivos = [
    { label: 'Ver todos', value: '' },
    { label: 'Filtrar: Ativos', value: 1 },
    { label: 'Filtrar: Inativos', value: 0 },
  ];

  const postaImagem = (gp) => {
    setIdGrupo(gp.Id);
    setModalImagemGrupo(true);
  };

  const alterarCardapioAtivo = async (grupoId, valor) => {
    try {
      await api.post('grupo-produto/alterarCardapioAtivo', {
        Id: grupoId,
        CardapioAtivo: valor,
      });
      setGrupos((state) =>
        state.map((grupo) => {
          if (grupo.Id !== grupoId) {
            return grupo;
          }

          return { ...grupo, CardapioAtivo: valor };
        }),
      );
      consultar();
    } catch (error) {
      toastError('Erro ao alterar Ativo Cardápio');
    }
  };

  const alterarStatus = async (obj, status) => {
    await api
      .patch(`grupo-produto/alterar/${obj.Id}`, {
        Descricao: obj.Descricao,
        CodigoPDV: obj.CodigoPDV,
        Ativo: status,
        Sequencia: obj.Sequencia,
      })
      .then((res) => {
        setGrupos((state) =>
          state.map((e) => {
            if (e.Id !== res.data.Id) {
              return e;
            }
            e = res.data;
            return e;
          }),
        );
        toastInfo('Grupo alterado');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const atualizar = async () => {
    await api
      .get(`grupo-produto/listarGestor/${id_empresa}`)
      .then((res) => {
        setGrupos(res.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const cadastrar = () => {
    setGrupo(null);
    setOpen(true);
  };

  const abrirDados = (gp) => {
    setGrupo(gp);
    setOpen(true);
  };

  const debounceSearch = debounce((valor) => {
    let instrucao = '';
    const value_lower = valor?.toLowerCase();

    instrucao +=
      filtroStatus !== '' ? ` Ativo='${filtroStatus}'` : ` Ativo IS NOT NULL`;
    instrucao += value_lower
      ? ` AND LOWER(Descricao) LIKE '%${value_lower}%'`
      : ``;
    consultar(instrucao);
    setBuscar(valor);
  }, 1000);

  useEffect(() => {
    debounceSearch(buscar ?? '');
  }, [filtroStatus]);

  return (
    <S.PageContainer>
      <ContentHeader
        title="Grupos"
        subtitle="Gerencie os grupos de produtos do cardápio"
        icon={FaLayerGroup}
        secondComponent={
          <InputGroup
            inside
            style={{
              width: '36vw',
              background: theme.colors.backgroundSecondary,
              border: `1px solid ${theme.colors.lightGray}60`,
              borderRadius: 8,
            }}
          >
            <CustomInput
              placeholder="Buscar grupo..."
              onChange={debounceSearch}
            />
            <InputGroup.Addon>
              <SearchIcon color={theme.colors.textSecondary} />
            </InputGroup.Addon>
          </InputGroup>
        }
        thirdComponent={
          <>
            <CustomSelectPicker
              data={dataAtivos}
              defaultValue={'Ativos'}
              value={filtroStatus}
              onChange={(value) => setFiltroStatus(value)}
              style={{ marginRight: '10px' }}
              searchable={false}
            />
            <CustomButton appearance="primary" onClick={cadastrar}>
              <PlusIcon style={{ marginRight: 6 }} /> Novo Grupo
            </CustomButton>
            <DuvidasButton tela="grupo" />
          </>
        }
      />

      <Table
        height={window.innerHeight - 60 - 90}
        data={grupos}
        bordered
        loading={loading}
        style={{
          borderColor: theme.colors.background,
          backgroundColor: theme.colors.background,
          color: theme.colors.textSecondary,
        }}
        locale={{
          emptyMessage: 'Nenhum grupo encontrado',
          loading: 'Carregando...',
        }}
      >
        <Column style={colStyle} align="center" width={110} fixed>
          <CustomHeaderCell>Código</CustomHeaderCell>
          <CustomCell dataKey="Id" />
        </Column>

        <Column style={colStyle} width={110}>
          <CustomHeaderCell>Código PDV</CustomHeaderCell>
          <CustomCell dataKey="CodigoPDV" />
        </Column>

        <Column style={colStyle} flexGrow={1}>
          <CustomHeaderCell>Descrição</CustomHeaderCell>
          <CustomCell dataKey="Descricao" />
        </Column>

        <Column style={colStyle} width={100} align="center">
          <CustomHeaderCell>Sequência</CustomHeaderCell>
          <CustomCell dataKey="Sequencia" />
        </Column>

        <Column style={colStyle} width={110} align="center">
          <CustomHeaderCell>Status</CustomHeaderCell>
          <CustomCell dataKey="Fim">
            {(rowData) => (
              <CustomButton
                appearance={rowData.Ativo ? 'primary' : 'ghost'}
                style={{ padding: '0px 12px' }}
                onClick={() => alterarStatus(rowData, !rowData.Ativo)}
              >
                {rowData.Ativo ? 'Ativo' : 'Inativo'}
              </CustomButton>
            )}
          </CustomCell>
        </Column>

        {!!company.CardapioAtivo && (
          <Column style={colStyle} width={145} align="center">
            <CustomHeaderCell>Cardápio Digital</CustomHeaderCell>
            <CustomCell dataKey="Fim">
              {(rowData) => (
                <CustomButton
                  appearance={rowData.CardapioAtivo ? 'primary' : 'ghost'}
                  style={{ padding: '0px 12px' }}
                  onClick={() =>
                    alterarCardapioAtivo(rowData.Id, !rowData.CardapioAtivo)
                  }
                >
                  {rowData.CardapioAtivo ? 'Ativo' : 'Inativo'}
                </CustomButton>
              )}
            </CustomCell>
          </Column>
        )}

        <Column style={colStyle} width={150} fixed="right">
          <CustomHeaderCell>Ações</CustomHeaderCell>
          <CustomCell>
            {(rowData) => (
              <S.OptionsCell>
                <CustomButton
                  onClick={() => abrirDados(rowData)}
                  appearance="primary"
                  size="xs"
                  color="#FF1493"
                >
                  Editar
                </CustomButton>
                <CustomButton
                  onClick={() => postaImagem(rowData)}
                  color="green"
                  appearance="primary"
                  size="xs"
                >
                  Imagem
                </CustomButton>
              </S.OptionsCell>
            )}
          </CustomCell>
        </Column>
      </Table>

      {open && (
        <EditarCadastrarGrupo
          modal={open}
          close={() => setOpen(false)}
          id_empresa={id_empresa}
          grupo={grupo}
          setGrupos={setGrupos}
          setGrupo={setGrupo}
        />
      )}

      {modalImagemGrupo && (
        <ModalImagemGrupo
          modal={modalImagemGrupo}
          close={() => setModalImagemGrupo(false)}
          id_empresa={id_empresa}
          grupo={grupo}
          idGrupo={idGrupo}
        />
      )}
    </S.PageContainer>
  );
};

export default Grupo;
